import { ChatStatusAction } from './types';

export const ToggleChatBotStatus = () => {
  return {
    type: ChatStatusAction.TOGGLE_CHATBOT
  };
};

export const StartChatBotLog = () => {
  return {
    type: ChatStatusAction.START_CHATBOT_LOG_REQUEST
  };
};

export const HideChatBot = () => {
  return {
    type: ChatStatusAction.HIDE_CHATBOT
  };
};
export const InitialLoading = () => {
  return {
    type: ChatStatusAction.INITIAL_LOADING
  };
};

export const LoadingChatBotEnd = () => {
  return {
    type: ChatStatusAction.LOADING_CHATBOT_END
  };
};
